module.exports = __webpack_public_path__ + "static/trendgraph-6151f400728b802bd22748ecbe0441f7.svg";